import styled from "styled-components";
import successIcon from "../../../../images/icon-roadmap-check.svg";
import partialIcon from "../../../../images/icon-alert-circle.svg";
import warningIcon from "../../../../images/icon-roadmap-cross.svg";
import React from "react";

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: 0.5px solid #4a4a4a;
    font-size: 18px;
    padding-bottom: 20px;
`;

const UpdateIcon = styled.img`
    flex-shrink: 0;
    height: 40px;
    width: 40px;
    margin-left: 4px;
    margin-right: 24px;
`;

const Text = styled.div`
    display: flex;
    line-height: 22px;
    font-weight: bold;
`;

const IdeaInfo = styled.div`
    line-height: 22px;
    margin-right: 6px;
`;

export const Headline = ({status, recommendation}) => {
    let icon;
    let message;

    switch (status) {
        case "success":
            icon = <UpdateIcon className="t-success-icon" src={successIcon}/>;
            message = "updated";
            break;
        case "partial":
            icon = <UpdateIcon className="t-partial-icon" src={partialIcon}/>;
            message = "partially updated";
            break;
        case "failed":
            icon = <UpdateIcon className="t-warning-icon" src={warningIcon}/>;
            message = "update failed";
            break;
    }

    return <Container>
        {icon}
        <Text className="t-update-headline">
            <IdeaInfo>{`${recommendation.direction} ${recommendation.bloomberg}`}</IdeaInfo> {message}
        </Text>
    </Container>
};